
    // import { Search } from '@alifd/next';
    // import type { SearchProps } from '@alifd/next/types/search';
    // import wrapper from './next-wrapper';

    // export type BLProFormSearchProps =SearchProps;

    // const BLProFormSearch = wrapper<BLProFormSearchProps>(Search, 'BLProFormSearch');

    // export default BLProFormSearch;

import { Input } from 'antd';
import { SearchProps } from 'antd/lib/input';
import wrapper from './next-wrapper';

export type BLProFormSearchProps = SearchProps;


const BLProFormSearch = wrapper<BLProFormSearchProps>(Input.Search, 'BLProFormSearch');
 
export default BLProFormSearch;


